import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PageContentModel } from 'src/app/models/page-content.model';
import { environment } from 'src/environments/environment';

declare function openNewTab(url: string): void

@Component({
    selector: 'app-black-button',
    templateUrl: './black-button.component.html',
    styleUrls: ['./black-button.component.scss'],
    standalone: false
})
export class BlackButtonComponent implements OnInit {

  @Input() pageContent: PageContentModel

  title: string
  routePath: string
  currentLang: string

  constructor(public translateService: TranslateService, private router: Router) {
    this.currentLang = translateService.currentLang

    translateService.onLangChange.subscribe(lang => {
      this.setTextByLanguage(lang.lang)
    })
  }

  ngOnInit(): void {
    this.setTextByLanguage(this.currentLang)
  }

  setTextByLanguage(lang: string) {
    if (lang == 'en') {
      this.title = this.pageContent.Title
      this.routePath = this.pageContent.Content
    } else {
      this.title = this.pageContent.TitleFr
      this.routePath = this.pageContent.ContentFr
    }
  }

  blackButtonClicked(contentRoute: string) {

    if (contentRoute.indexOf('eligibility') > -1) {
      let gatewayUrl = environment.apiBaseUrl.replace('api/', '') + contentRoute
      this.router.navigate([]).then(result => {
        openNewTab(gatewayUrl);
      })
    } else {
      this.router.navigate([contentRoute])
    }
  }
}
